import { defineComponent } from 'navigation-components/platform/models';
import { capabilities } from '../../capabilities';
import { args } from '../../common/args';
import { getPortalId } from '../../common/utils';
import { GLOBAL_SEARCH_COMPONENT } from '../constants';
const GLOBAL_SEARCH_FILTER_QUERY_PARAM = 'searchFilters';
const GLOBAL_SEARCH_PREFILTERED_QUERY_PARAM = 'preFiltered';
function getSearchFiltersQueryParam() {
  const urlQueryParams = new URLSearchParams(window.location.search);
  return urlQueryParams.get(GLOBAL_SEARCH_FILTER_QUERY_PARAM) || '';
}
function getSearchPreFilteredQueryParam() {
  const urlQueryParams = new URLSearchParams(window.location.search);
  return urlQueryParams.get(GLOBAL_SEARCH_PREFILTERED_QUERY_PARAM) || '';
}
export const globalSearchComponentDef = defineComponent(GLOBAL_SEARCH_COMPONENT, () => {
  const appPath = 'global-search-ui';
  return {
    name: GLOBAL_SEARCH_COMPONENT,
    path: `${appPath}/${getPortalId()}`,
    queryParams: {
      isMinifiedSearch: 'true'
    },
    scrolling: false,
    capabilities: [capabilities.UPDATE_QUERY_PARAM_CAP.getName(), capabilities.SHOW_COMPONENT_CAP.getName(), capabilities.HIDE_COMPONENT_CAP.getName(), capabilities.GLOBAL_KEYBOARD_SHORTCUT_HANDLER_CAP.getName(), capabilities.CHANGE_SEARCH_FILTER_CAP.getName(), capabilities.CHANGE_SEARCH_CAP.getName(), capabilities.ADD_TO_BOOKMARKS_CAP.getName(), capabilities.RESTYLE_CAP.getName()],
    iframeProps: {
      style: {
        transition: 'height 0.1s ease'
      },
      id: 'global-search',
      ['data-test-id']: 'global-search-iframe',
      title: 'global-search-iframe'
    },
    propsSchema: {
      searchQuery: args.string(),
      searchFilters: args.string(),
      searchPreFiltered: args.optional(args.string())
    },
    initialProps: {
      searchQuery: '',
      searchFilters: getSearchFiltersQueryParam(),
      searchPreFiltered: getSearchPreFilteredQueryParam()
    },
    functions: {
      keyDown: {
        args: {
          keyboardEventKeys: args.keyboardEventKeys()
        }
      },
      searchInFocus: {
        args: {
          isFocused: args.bool()
        }
      },
      searchWrapperResize: {
        args: {
          width: args.number(),
          height: args.number()
        }
      },
      executeBreezeWidget: {
        args: {}
      },
      onFormSubmit: {
        args: {}
      }
    },
    deferLoading: true,
    renderTo: () => document.querySelector('#search-results'),
    initiallyOpen: false
  };
});